// src/components/modals/BlackCardModal.js
import React from 'react';
import Modal from '../shared/Modal';
import Button from '../shared/Button';
import './BlackCardModal.css';

/**
 * Modal for Judge to create custom black cards
 */
function BlackCardModal({
  show,
  onClose,
  blackCardText,
  setBlackCardText,
  onCreateCard,
  czarWriteInTimer,
}) {
  const footer = (
    <>
      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={onCreateCard}
        disabled={!blackCardText.trim() || czarWriteInTimer === 0}
      >
        Create Question Card
      </Button>
    </>
  );

  return (
    <Modal
      show={show}
      onClose={onClose}
      title="✍️ Write Custom Question Card"
      footer={footer}
      size="md"
      contentClassName="black-card-modal"
    >
      <p>Create a custom question card with 1-2 blanks (use _ for each blank):</p>
      <p className="example-text">Examples: "The secret to happiness is _" or "I like _ and _"</p>
      <textarea
        value={blackCardText}
        onChange={(e) => setBlackCardText(e.target.value)}
        placeholder="Example: The secret to happiness is _."
        maxLength={300}
        className="black-card-textarea"
        autoFocus
      />
      <div className="character-count">{blackCardText.length}/300 characters</div>

      {czarWriteInTimer > 0 && (
        <div className="timer-display">Time remaining: {czarWriteInTimer}s</div>
      )}
    </Modal>
  );
}

export default BlackCardModal;
